<template>
	<div class="classTeacher">
		<el-dialog title="设置班级关联教师" :close-on-click-modal='false' center :visible.sync="dialogVisible" width="50%"
			:before-close="handleClose">
			<div class="block">
				<el-cascader v-model="selectData" :options="options" :props="{ multiple: true }" style="width: 100%;"
					clearable placeholder='请选择关联教师'>
				</el-cascader>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="saveClassTeacher">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				options: [],
				selectData: ''
			}
		},
		props: {
			dialogVisible: {
				default: false,
				type: Boolean
			},
			classID: {
				type: String
			}
		},
		created() {

		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.loadData()
				}
			}
		},
		methods: {
			handleClose() {
				this.$emit("before-close")
			},
			saveClassTeacher() {
				let teacherlist = this.selectData.map(item => {
					return item[2]
				})
				// 保存选择的数据
				this.$http.post('api/org/EditClassTeachers', {
					TeacherList: teacherlist,
					ClassID: this.classID
				}).then(res => {
					if (res.data.code == 1) {
						this.handleClose()
					}
				})
			},
			loadData() {
				this.$http.get('api/org/GetClassTeacherData/' + this.classID).then(res => {
					if (res.data.code == 1) {
						this.options = res.data.data.options
						if (res.data.data.selectData) {
							this.selectData = res.data.data.selectData
						} else {
							this.selectData = []
						}
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.classTeacher {
		// .el-cascader-menu__wrap{
		// 	height: 200px;
		// }
		// .el-cascader-menu{
			
		// }
	}
</style>
